import React, { useState } from 'react';
import { AccordionItem, Box, Inscription } from '@common-fe/common-fe';

import { Renewal, RenewalStatus } from '../../renewals.types';
import { RenewalPlanOptionValues } from '../RenewalSetup.types';
import { useRenewalSetupStore } from '../stores';

const AVAIBLE_OPTIONS = [
  {
    label: (
      <Inscription lineHeight='20px' color="textBody">
        <span style={{ fontWeight: 'bold' }}>1. Census</span> - add any new employees.
      </Inscription>
    ),
  },
  {
    label: (
      <Inscription lineHeight='20px' color="textBody">
        <span style={{ fontWeight: 'bold' }}>2. Enrollment</span> - add elections for all employees enrolled in the new plan year.
      </Inscription>
    ),
  },
  {
    label: (
      <Inscription lineHeight='20px' color="textBody">
        <span style={{ fontWeight: 'bold' }}>3. Contributions</span> - get ready to fund the account.
      </Inscription>
    ),
  },
];

interface Props {
  renewalSetupData?: Renewal;
}

const NextSteps: React.FC<Props> = ({ renewalSetupData }) => {
  const [isExpanded, setExpanded] = useState(true);
  const plansPlanYearSelectedOption = useRenewalSetupStore((state) => state.plansPlanYear.selectedOption);

  return (
    <Box
      onClick={() => setExpanded(!isExpanded)}
      border={{ color: 'border1', size: 'large' }}
      pad={{ vertical: 's', horizontal: 'm' }}
      round="container1Round"
      background={isExpanded ? 'border1' : 'canvas'}
      width="100%"
      margin={{ top: 's' }}
      data-testid="next-steps"
    >
      <AccordionItem
        testId='copays-summary-item'
        iconSize='24px'
        isExpanded={isExpanded}
        text={(
          <Box
            background={isExpanded ? 'border1' : 'canvas'}
            margin={{ left: 'xxxs' }}
            direction="row"
            align="center"
          >
            <Inscription color="textBody" weight="normal" lineHeight='20px'>
              Next Steps
            </Inscription>
          </Box>
        )}
        isLeftArrow
      >
        {
          plansPlanYearSelectedOption === RenewalPlanOptionValues.ACTIVE 
          || renewalSetupData?.status === RenewalStatus.ACTIVE ? (
            <Box
              background="border1"
              margin={{ top: 'xs' }}
              direction="column"
            >
              {AVAIBLE_OPTIONS.map((option) => (
                option.label
              ))}
            </Box>
          ) : (
            <Inscription lineHeight='20px' color="textBody">
              {renewalSetupData?.partnerName} will reach out shortly with next steps.
            </Inscription>
          )
        }
      </AccordionItem>
    </Box>
  );
};

export default NextSteps;
